import React from "react";
export function TabStrip({ tabs = [], value, onSelect, style = {} }) {
  return (
    <div className="tabstrip" style={{ display: "flex", alignItems: "center", gap: 2, height: 38, overflowX: "auto", overflowY: "hidden", ...style }}>
      {tabs.map((t) => {
        const label = typeof t === "string" ? t : t.label;
        const on = label === value;
        return <button key={label} title={label} onClick={() => onSelect && onSelect(label)} style={{
          display: "flex", alignItems: "center", gap: 6, flex: "none", height: 28, padding: "0 11px",
          background: on ? "var(--bg-sel)" : "transparent", border: "none", borderRadius: "var(--r-tile)",
          color: on ? "var(--fg-1)" : "var(--fg-7)", fontFamily: "inherit", fontSize: "var(--fs-12)",
          fontWeight: on ? "var(--fw-semibold)" : "var(--fw-regular)", cursor: "pointer", whiteSpace: "nowrap",
        }}>
          {label}
          {typeof t === "object" && t.count != null ? <span style={{ padding: "0 5px", borderRadius: "var(--r-pill)", background: "color-mix(in srgb, var(--ac-blue) 16%, transparent)", color: "var(--ac-blue)", fontSize: "var(--fs-10)", fontWeight: "var(--fw-semibold)" }}>{t.count}</span> : null}
        </button>;
      })}
    </div>
  );
}
